import React, { FC } from 'react'
import cn from '../../../../../lib/utils/cn'
import { Button, IconButton } from '../../../../ui'
import { Close } from '@mui/icons-material'

interface SearchModeSwitcherProps {
	currentTab: string
	setCurrentTab: (value: string) => void
	tabs: string[]
	onClose: () => void
}

const SearchModeSwitcher: FC<SearchModeSwitcherProps> = ({
	currentTab,
	setCurrentTab,
	tabs,
	onClose
}) => {
	const getTabLabel = (tab: string) => {
		switch (tab) {
			case 'quick-search':
				return 'Quick Search'
			case 'ai-search':
				return 'Ask AI'
			default:
				return tab
		}
	}

	return (
		<div className='flex items-center justify-start gap-2'>
			<div className="flex flex-row items-center border border-stroke-light dark:border-stroke-light-dark  rounded-lg overflow-hidden h-[35px] w-full">
				{tabs.map((tab, index) => (
					<Button
						key={index}
						variant="transparent"
						label={getTabLabel(tab)}
						onClick={() => setCurrentTab(tab)}
						className={cn(
							'flex-1 flex items-center justify-center h-full transition-color text-xs font-semibold',
							index > 0 &&
							'border-l border-stroke-light dark:border-stroke-light-dark ',
							index === 0 && 'rounded-l-lg rounded-r-none p-0',
							index === tabs.length - 1 && 'rounded-r-lg rounded-l-none p-0',
							index === 1 && 'rounded-none',
							currentTab === tab
								? 'bg-text-main hover:hover:bg-background-dark text-white dark:bg-text-main-dark dark:text-text-main dark:hover:text-white'
								: 'bg-white dark:bg-background-dark text-text-main dark:text-text-main-dark hover:bg-stroke-dark dark:hover:bg-stroke-light-dark'
						)}
					/>
				))}
			</div>
			<IconButton
				tooltip='Close'
				variant="transparent"
				className="min-w-10 h-10"
				onClick={onClose}
				icon={
					<Close className="w-5 h-5 fill-text-secondary dark:fill-text-main-dark" />
				}
			/>
		</div>
	)
}

export default SearchModeSwitcher
